import { Button, Typography } from 'antd';
import { useHistory, useParams } from 'react-router-dom';
import styled from 'styled-components';

import { Logo, MainSection } from '../../pages/LandingPage/styles';
import { ROUTE_PREFIX_BOOKING } from '../../constants/routes';
import { CONTACT_PHONE } from '../../constants/business';

const Container = styled.section`
  padding: 45px 10px;
  text-align: center;
`;

const TextSection = styled.section`
  padding: 10px 30px;
  font-size: 18px;
`;

const { Title } = Typography;

const ErrorFallback = () => {
  const { workflowId } = useParams();

  const history = useHistory();
  const resetErrorBoundary = () => {
    history.push(`${ROUTE_PREFIX_BOOKING}/${workflowId}`);
  };

  return (
    <Container>
      <header>
        <Logo alt="logo" width="70%" height="68px" src="/assets/slogan.svg" />
      </header>
      <MainSection>
        <Title level={2} style={{ marginBottom: '50px' }}>
          Oops! Something went wrong...
        </Title>
      </MainSection>
      <TextSection style={{ marginBottom: '50px' }}>
        <Title level={4} style={{ fontWeight: 'normal' }}>
          Please contact Telecare at ({CONTACT_PHONE}) or via live chat.
        </Title>
      </TextSection>
      <div style={{ textAlign: 'center' }}>
        <picture>
          <source
            srcSet={`${process.env.PUBLIC_URL}/assets/doctors-image.webp`}
            type="image/webp"
            width="50%"
          />
          <source
            srcSet={`${process.env.PUBLIC_URL}/assets/doctors-image.svg`}
            type="image/svg"
            width="50%"
          />
          <img
            src={`${process.env.PUBLIC_URL}/assets/doctors-image.svg`}
            alt="Ops something went wrong"
            width="50%"
          />
        </picture>
      </div>
      {workflowId && (
        <Button onClick={resetErrorBoundary}>Back to landing page</Button>
      )}
    </Container>
  );
};

export default ErrorFallback;
